<template>
    <div class="emc_card px-4 list-item-component">
        <div class="vx-row">
            <div
                class="vx-col w-full flex sm:items-center sm:flex-row flex-col mt-4"
            >
                <div class="flex flex-wrap">
                    <vs-chip color="warning">{{ item.discipline }} </vs-chip>
                    <vs-chip color="primary">
                        {{ item.language }}
                    </vs-chip>
                    <vs-chip color="success">
                        {{ item.short_load_type }}
                    </vs-chip>
                </div>
            </div>
            <div class="mt-1">
                <div class="flex flex-wrap mx-4">
                    <span class="mr-2 font-semibold"
                        >{{ $t("count_hours") }}:</span
                    >
                    <div>{{ item.hours }}</div>
                </div>
                <div class="flex flex-wrap mx-4">
                    <span class="mr-2 font-semibold"
                        >{{ $t("count_reg_students") }}:</span
                    >
                    <div>{{ item.student_count }}</div>
                </div>
                <div class="flex flex-wrap mx-4">
                    <div class="font-semibold">{{ item.acad_period_repr_name }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    computed: {},
};
</script>

<style scoped lang="scss">
@media only screen and (max-width: 900px) {
    .user_detail {
        flex-wrap: wrap;
        .sender__avatar {
            margin-left: 0px;
        }
        .user_name,
        .mobile_div {
            width: 100%;
        }
    }
    .user_date {
        margin-top: 5px;
    }
    .todo-title {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
}
</style>
